export default {"container":"pS0GV","top-bar":"_2-S-p","content":"ullkC","contentOnBoarding":"Oj39z","bottom":"LwTKZ"};